import USER_TYPES from '@/constants/authorization/user-types'
import store from '@/store'
import { BUSINESS_FEATURES } from '@/constants/business-types'
import { PACKAGE_PERMISSIONS } from '@/constants/features'
import posRoutes from '@/navigation/vertical/admin/POS'
import customerRoutes from '@/navigation/vertical/admin/customer'
import reportsRoutes from '@/navigation/vertical/admin/reports'
import inventoryRoutes from '@/navigation/vertical/admin/inventory'

export default [
  // {
  //   header: 'navigation.management',
  // },
  {
    title: 'navigation.orders',
    svgIcon: 'icon-orders',
    route: 'admin:orders',
  },
  {
    title: 'display-devices.devices',
    route: 'admin:display-devices',
    svgIcon: 'icon-kds-devices',
    userTypes: [USER_TYPES.OWNER],
  },
  {
    title: 'features.order-display-system',
    tag: 'upgrade',
    tagPackagePermission: PACKAGE_PERMISSIONS.KITCHEN,
    svgIcon: 'icon-ods',
    hide: () => store.getters['ordering/isDineinViewOnlyEnabled'] || !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.KITCHEN),
    route: 'admin:kitchen',
  },
  {
    title: 'navigation.transactions',
    svgIcon: 'icon-payment-transactions',
    hide: () => !store.getters['subscription/isOnlinePaymentPurchased'],
    route: 'admin:transactions',
    userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR],
  },
  ...customerRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] })),
  ...reportsRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] })),
  ...posRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] })),
  ...inventoryRoutes,
  {
    title: 'navigation.reservations',
    tag: 'upgrade',
    tagPackagePermission: PACKAGE_PERMISSIONS.RESERVATION,
    svgIcon: 'icon-reservation',
    route: 'admin:reservations',
    hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.RESERVE_TABLE),
  },
  {
    title: 'navigation.queues',
    tag: 'upgrade',
    tagPackagePermission: PACKAGE_PERMISSIONS.QUEUE,
    svgIcon: 'icon-queue',
    route: 'admin:queues',
    hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.QUEUE) || store.getters['subscription/isQr'],
  },
  {
    title: 'statistics.statistics',
    tag: 'upgrade',
    tagPackagePermission: PACKAGE_PERMISSIONS.STATISTICS,
    route: 'admin:statistics',
    svgIcon: 'icon-statistics',
    userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.AUDITOR],
  },
  {
    title: 'navigation.branches-statistics',
    tag: 'upgrade',
    tagPackagePermission: PACKAGE_PERMISSIONS.STATISTICS,
    route: 'admin:branches-statistics',
    svgIcon: 'icon-branches-statistics',
    userTypes: [USER_TYPES.BRANCH_ADMIN, USER_TYPES.AUDITOR],
  },

]
